import moment from 'moment'
import ft from '../featureToggle'

export default {
  getNotes  (VueApp, provId, callback) {
    let notes = VueApp.$store.state.provider.notes
    let pageSize = notes.pageSize
    let page = notes.pageNum

    VueApp.$sdk.get('/provider/' + provId + '/notes', {
      token: VueApp.$store.state.session.sessionToken,
      order: 'created',
      orderAsc: 0,
      pageSize: pageSize,
      pageNum: page + 1
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('provider/setNotesPage', page + 1)

        if (res.list.length < pageSize) {
          VueApp.$store.commit('provider/setNotesIsMax', true)
        }

        if (res.list.length) {
          let note = res.list
          for (let i = 0; i < res.list.length; i++) {
            let date = moment.utc(note[i].created, 'YYYY-MM-DD@hh:mm:ss').tz('America/Los_Angeles')
            let admin = {
              name: 'Deleted Admin',
              id: 0,
              pic: 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg'
            }
            if (note[i].admin) {
              admin = {
                name: note[i].admin.firstName + ' ' + note[i].admin.lastName,
                id: note[i].admin.id,
                pic: note[i].admin.avatarUrl
              }
            }
            VueApp.$store.commit('provider/addNotes', {
              id: note[i].id,
              date: date.format('MM/DD/YYYY ' + ft.timeFormat(VueApp, false)),
              message: note[i].message,
              status: note[i].status,
              userId: admin.id || 0,
              name: admin.name,
              picture: admin.pic || 'https://s3-us-west-2.amazonaws.com/staging-backoffice/staging/default-user.jpg'
            })
          }
        }
      }
      callback(res)
    })
  },
  deleteNote (VueApp, noteId, callback) {
    VueApp.$sdk.delete('/note/' + noteId, {
      token: VueApp.$store.state.session.sessionToken
    }, res => {
      if (!res.error) {
        VueApp.$store.commit('provider/deleteNote', noteId)
      }
      callback(res)
    })
  }
}



// WEBPACK FOOTER //
// ./src/modules/api/provider/notes.js